import { TextField } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import InputMask from "react-input-mask";
import moment from "moment"

const InvoiceDueDate = () => {
  const { values, handleChange, handleBlur, touched, errors } =
    useFormikContext();
  return (
    <InputMask
      mask="99/99/9999"
      value={values["payment_due_date"]}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={(e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("Text");
        const fieldName = e.target.name;
        handleChange({
          target: {
            name: fieldName,
            value: moment(pastedData).format("MM/DD/YYYY"),
          },
        });
      }}
    >
      {() => (
        <TextField
          label="Due Date"
          error={touched.payment_due_date && Boolean(errors.payment_due_date)}
          helperText={touched.payment_due_date && errors.payment_due_date}
          required
          size="small"
          name="payment_due_date"
        />
      )}
    </InputMask>
    // <TextField
    //   fullWidth
    //   size="small"
    //   label="Due Date"
    //   value={values["payment_due_date"]}
    //   name="payment_due_date"
    //   onChange={handleChange}
    //   onBlur={handleBlur}
    //   error={touched.payment_due_date && Boolean(errors.payment_due_date)}
    //   helperText={touched.payment_due_date && errors.payment_due_date}
    // />
  );
};

export default InvoiceDueDate;
